module.exports = __webpack_public_path__ + "static/media/4ODA19.78bc6d4e.jpg";